import React, {useState} from 'react';
import {bindActionCreators, compose} from 'redux';
import * as reviewsActions from '../../actions/reviewsActionCreators';
import {connect} from 'react-redux';
import {Input, Rate, Select} from 'antd';
import CustomCheckbox from '../Checkbox';
import TextArea from 'antd/es/input/TextArea';
import Button from '../Button';
import './style.scss';
import './mobile.scss';

const ReviewForm = (props) => {
  const
    initialState = {
      stars: 3,
      author: '',
      anonymous: false,
      city: '',
      merits: '',
      limitations: '',
      comment: '',
      send_to_email: false,
      email: ''
    },
    errors = props.reviewsState.newReview?.errors,
    clearErrors = () => {
      errors && props.reviewsActions.resetNewReview();
    },
    [reviewState, setReviewState] = useState({...initialState}),
    setRate = (value) => {
      setReviewState({
        ...reviewState,
        stars: value
      })
    },
    handleChange = (attr, type = 'text') => (event) => {
      const newState = {...reviewState, [attr] : type === 'boolean' ? event.target.checked : (type === 'text' ? event.target.value : event)};
      setReviewState(newState);
      clearErrors();
    },
    handleSubmit = () => {
      props.reviewsActions.createReview(reviewState);
    },
    {author, send_to_email, email, anonymous, stars} = reviewState,
    isReviewInvalid = !stars || (!anonymous && !author) || (send_to_email && !email);

  return (
    <div className='form review-form'>
      <div className='form__section'>
        <div className='form__section-title'>
          <span>Ваша оценка:</span>
          <Rate onChange={setRate} value={reviewState.stars} />
        </div>
      </div>
      <div className='form__section'>
        <div className='form__section-title'>Представьтесь</div>
        <div className='form__field'>
          <div className='form__field-label'>Имя</div>
          <div className='form__field-input'>
            <Input
              onChange={handleChange('author')}
              value={reviewState.author}
              className={`${errors?.author ? 'error' : ''}`}
            />
            <div className='form__field-help'>
              <CustomCheckbox
                onChange={handleChange('anonymous', 'boolean')}
                checked={reviewState.anonymous}
              >
                Оставить анонимный отзыв
              </CustomCheckbox>
            </div>
          </div>
        </div>
        <div className='form__field'>
          <div className='form__field-label'>Город</div>
          <div className='form__field-input'>
            <Select
              style={{width: 200}}
              options={[...props.applicationState.cities.map(city => ({label: city.name, value: city.name}))]}
              onSelect={handleChange('city', 'select')}
            />
          </div>
        </div>
      </div>
      <div className='form__section'>
        <div className='form__section-title'>Расскажите подробнее</div>
        <div className='form__field'>
          <div className='form__field-label'>Достоинства</div>
          <div className='form__field-input'>
            <TextArea
              onChange={handleChange('merits')}
              value={reviewState.merits}
              placeholder="Что вам понравилось"
              style={{height: 80}}
            />
          </div>
        </div>
        <div className='form__field'>
          <div className='form__field-label'>Недостатки</div>
          <div className='form__field-input'>
            <TextArea
              onChange={handleChange('limitations')}
              value={reviewState.limitations}
              placeholder="Что вам не понравилось"
              style={{height: 80}}
            />
          </div>
        </div>
        <div className='form__field'>
          <div className='form__field-label'>Комментарий</div>
          <div className='form__field-input'>
            <TextArea
              onChange={handleChange('comment')}
              value={reviewState.comment}
              placeholder="Ваши впечатления о нашей работе"
              style={{height: 80}}
            />
          </div>
        </div>
        <div className='form__field'>
          <div className='form__field-label'></div>
          <div className='form__field-input'>
            <div className='form__field-help'>
              <CustomCheckbox
                onChange={handleChange('send_to_email', 'boolean')}
                checked={reviewState.send_to_email}
              >
                Отправить ответ на электронную почту
              </CustomCheckbox>
            </div>
            {
              reviewState.send_to_email ?
                <Input
                  onChange={handleChange('email')}
                  placeholder='Электронная почта'
                  className={`${errors?.email ? 'error' : ''}`}
                  value={reviewState.email}
                />
                : null
            }
          </div>
        </div>
      </div>
      <div className='form__section'>
        <div className='form__field'>
          <div className='form__field-label'></div>
          <div className='form__field-input'>
            <Button disabled={isReviewInvalid} onClick={handleSubmit}>Отправить отзыв</Button>
          </div>
        </div>
      </div>
    </div>
  );
}

const mapDispatchToProps = (dispatch) => {
    return {
      reviewsActions: bindActionCreators(reviewsActions, dispatch)
    };
  },

  mapStateToProps = ({reviewsState, railsContext, applicationState}) => {
    return {
      applicationState,
      reviewsState,
      railsContext
    };
  },

  withConnect = connect(
    mapStateToProps,
    mapDispatchToProps
  );

export default compose(withConnect)(ReviewForm);

